import styled from 'styled-components'

const ContactStyle = styled.div`
  min-height: 50vh;
  background-color: ${(props) => props.theme.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 99.5vw;
  padding-top: 5vh;
  position: relative;

  .contact-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50vw;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  input {
    padding: 0.5rem;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.16);
    width: 48%;
    color: ${(props) => props.theme.text};
  }

  textarea {
    padding: 0.5rem;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.16);
    width: 100%;
    min-height: 15vh;
    color: ${(props) => props.theme.text};
  }

  button {
    background-color: rgb(0, 0, 0, 0.75);
    color: ${(props) => props.theme.text};
    padding: 0.5rem 1rem;
    background: linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85))
        padding-box,
      linear-gradient(-205deg, ${(props) => props.theme.primary},
          ${(props) => props.theme.secondary}) border-box;
    border-radius: 0.25rem;
    border: 2px solid transparent;
    color: darkblue;
    padding: 0.5rem 1rem;
    margin-bottom: 2rem;
    color: ${(props) => props.theme.text};
    cursor: pointer;
  }

  .invalid {
    color: red;
  }

  .sent-message {
    color: ${(props) => props.theme.primary};
    position: absolute;
    bottom: -1.5rem;
    transition: all 0.5s ease-in-out;
  }

  .error-message {
    color: red;
  }


  @media (max-width: 768px) {
    .input-container {
      flex-direction: column;
    }
    .contact-container {
      width: 80vw;
    }
    input {
      width: 100%;
      margin-top: 1rem;
    }
`

export default ContactStyle
